import React from 'react';
import BuyableIcon from '@material-ui/icons/CheckOutlined';
import NotBuyableIcon from '@material-ui/icons/CloseOutlined';
import { green, red } from '@material-ui/core/colors';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
	buyableIcon: {
		color: green[400],
	},
	notBuyableIcon: {
		color: red[400],
	},
	root: {
		'& svg': {
			verticalAlign: 'middle',
		},
	},
}));
// isBuyable on lows.com status indicator component.
const ProductBuyable = ({ isBuyable }) => {
	const classes = useStyles();
	const fieldVal = isBuyable === 'Y' ? 'Yes' : 'No';
	if (isBuyable) {
		const icon =
			isBuyable === 'Y' ? (
				<BuyableIcon className={classes.buyableIcon} />
			) : (
				<NotBuyableIcon className={classes.notBuyableIcon} />
			);
		return (
			<span className={classes.root}>
				{icon}
				{fieldVal}
			</span>
		);
	}
	return null;
}

export default ProductBuyable;
